import React from 'react';
export const Hero = () => {
  return <section className="w-full pt-24 pb-16 px-6 md:px-12 bg-white transition-colors" data-id="element-41">
      <div className="max-w-7xl mx-auto" data-id="element-42">
        <h1 className="text-4xl md:text-6xl font-bold text-[#070707] leading-tight mb-8 transition-colors" data-id="element-43">
          We are an early stage
          <br data-id="element-44" />
          venture capital fund specializing
          <br data-id="element-45" />
          in all things enterprise & infrastructure.
        </h1>
        <p className="text-xl md:text-2xl text-[#070707] max-w-4xl transition-colors" data-id="element-46">
          We've built highly successful companies before and are ready to help
          you do the same — with speed.
        </p>
      </div>
    </section>;
};